module.exports = {
      id: "1294d784f6ea490206fd8e6b4d02af60equipment-motion-alarm.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#1294d784f6ea490206fd8e6b4d02af60equipment-motion-alarm.svg",
      toString: function () {
        return this.url;
      }
    }